import { Bot } from "lucide-react";

const FloatingHukukAI = () => {
  const handleClick = () => {
    window.open('/ai.html', "_blank", "noopener,noreferrer");
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-double-bounce">
      <button
        onClick={handleClick}
        className="
          flex items-center gap-2
          pl-3 pr-6 py-2
          rounded-l-3xl
          rounded-tr-0
          rounded-br-3xl    
          bg-white dark:bg-dark-box
          shadow-xl shadow-black/20 dark:shadow-black/40
          hover:shadow-4xl
          transition-all duration-300
          hover:-translate-y-1
          
          border border-[#cfd8e6] dark:border-dark-border
        "
      >
        <div className="w-9 h-9 flex items-center justify-center 
                         rounded-3xl bg-primary text-white">
          <Bot size={20} />
        </div>
        <span className="inline font-semibold 
                       text-primary dark:text-dark-text">
          Kazyýet AI
        </span>
      </button>
    </div>
  );
};

export default FloatingHukukAI;